// src/components/ChatBot.jsx
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";

const ChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { text: "Hi! How can I assist you today?", sender: "bot" },
  ]);
  const [userInput, setUserInput] = useState("");

  const projects = {
    residential: [
      {
        name: "Parkview Residences",
        address: "123 Park Ave, Springfield",
        description:
          "A beautiful 3-bedroom apartment with a scenic view of the park.",
        priceRange: "$200,000 - $300,000",
        availability: "Available Now",
      },
      {
        name: "Lakeside Apartments",
        address: "456 Lake Rd, Springfield",
        description: "Luxury 2-bedroom apartment near the lake.",
        priceRange: "$250,000 - $350,000",
        availability: "Coming Soon",
      },
    ],
    commercial: [
      {
        name: "Downtown Tower",
        address: "789 Main St, Springfield",
        description: "Premium office space in the heart of downtown.",
        priceRange: "$1,000 - $2,000 per month",
        availability: "Available Now",
      },
      {
        name: "Tech Park",
        address: "101 Innovation Dr, Springfield",
        description: "Modern co-working spaces for tech startups.",
        priceRange: "$500 - $1,500 per month",
        availability: "Limited Availability",
      },
    ],
  };

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  const handleSendMessage = () => {
    if (userInput.trim() !== "") {
      const userMessage = userInput.toLowerCase();
      let botResponse = "";

      // Handle greetings like "Hi" and "Hello"
      if (userMessage.includes("hi") || userMessage.includes("hello")) {
        botResponse =
          "Hello! How can I help you today? You can ask about our residential or commercial projects.";
      } else {
        // Search through the projects for matches
        let foundProject = false;
        for (let category in projects) {
          for (let project of projects[category]) {
            if (userMessage.includes(project.name.toLowerCase())) {
              botResponse =
                `Here are the details for ${project.name}:\n\n` +
                `Address: ${project.address}\n` +
                `Description: ${project.description}\n` +
                `Price Range: ${project.priceRange}\n` +
                `Availability: ${project.availability}`;
              foundProject = true;
              break;
            }
          }
          if (foundProject) break;
        }

        // Default response if no matching project found
        if (!botResponse) {
          botResponse =
            "Sorry, I didn't quite understand that. Can you ask about a specific project?";
        }
      }

      setMessages([
        ...messages,
        { text: userInput, sender: "user" },
        { text: botResponse, sender: "bot" },
      ]);
      setUserInput("");
    }
  };

  return (
    <div>
      {/* Chat icon button */}
      <button
        className="fixed bottom-4 left-4 bg-blue-500 text-white p-4 rounded-full shadow-xl hover:bg-blue-600 transition duration-300 ease-in-out transform hover:scale-110"
        onClick={toggleChat}
      >
        <FontAwesomeIcon icon={faComments} className="h-6 w-6" />
      </button>

      {/* Chat window */}
      {isOpen && (
        <div className="fixed bottom-16 left-4 w-80 h-96 bg-white border border-gray-300 rounded-lg shadow-lg p-4 transition-all duration-500 ease-in-out transform scale-100 hover:scale-105">
          <div className="flex flex-col h-full">
            {/* Chat messages */}
            <div className="flex-1 overflow-y-auto space-y-3">
              {messages.map((message, index) => (
                <div
                  key={index}
                  className={`flex ${
                    message.sender === "bot" ? "justify-start" : "justify-end"
                  }`}
                >
                  <div
                    className={`p-3 rounded-lg max-w-xs break-words ${
                      message.sender === "bot"
                        ? "bg-gray-200 text-gray-800"
                        : "bg-blue-500 text-white"
                    }`}
                  >
                    {message.text}
                  </div>
                </div>
              ))}
            </div>

            {/* Input area */}
            <div className="flex mt-2">
              <input
                type="text"
                className="flex-1 border border-gray-300  rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={userInput}
                onChange={(e) => setUserInput(e.target.value)}
                placeholder="Type your message..."
              />
              <button
                className="bg-blue-500 text-white p-1 rounded-r-lg hover:bg-blue-600 transition duration-200 ease-in-out"
                onClick={handleSendMessage}
              >
                Send
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatBot;
